import { FC, useContext } from "react";
import { useNavigate } from "react-router";

import { Button, Link } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Heading } from "capitalrx-components-2.0/lib/typography";

import { ThemeSelectorContext } from "@/context";
import { getThemeButton, getThemeURL } from "@/utils";

import styles from "./PharmacyFileSent.module.scss";


export const PharmacyFileSent: FC = () => {
  const navigate = useNavigate();
  const { primary_color, primary_hover_color } = useContext(ThemeSelectorContext);


  return (
    <div className={styles.PharmacyFormContainer}>
      <Stack spacing="medium-large">
        <Heading className={styles.PharmacyFormCenterText} testId="test__file_sent">File Sent</Heading>
        <Stack spacing="medium">
          <Body className={styles.PharmacyFormCenterText}>
            If a match is found, a file will been sent to the email address on record.
          </Body>
          <Body className={styles.PharmacyFormCenterText}>
            If you do not receive a file, confirm the information entered and submit a new request.
          </Body>
        </Stack>
        <Stack spacing="large">
          <Shelf>
            <Shelf.Spacer />
            <Button
              onClick={() => navigate(getThemeURL("PHARMACY"))}
              appearance={getThemeButton("primary", primary_color, primary_hover_color)}
            >
              Request Another File
            </Button>
            <Shelf.Spacer />
          </Shelf>
          <Shelf>
            <Shelf.Spacer />
            <Link to={getThemeURL("HOME")} style={{ color: primary_color }}>Exit Pharmacy</Link>
            <Shelf.Spacer />
          </Shelf>
        </Stack>
      </Stack>
    </div>
  );
};

export default PharmacyFileSent;
